module.exports = __webpack_public_path__ + "assets/img/Ic-24h.5d6a07c2.svg";